import React from 'react'
import { IconPlus } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { TextInput } from '@/components/forms/TextInput'

export const AddCategoryForm = ({ value, onChange, onSubmit }) => {
  const handleSubmit = (event) => {
    event.preventDefault()
    onSubmit()
  }

  return (
    <form className="manage-tags__add-category" onSubmit={handleSubmit}>
      <TextInput placeholder="New category name" value={value} onChange={onChange} />
      <Button
        brand
        icon={<IconPlus />}
        type="submit"
        data-testid="add_category_button"
        disabled={!value}
      >
        Add category
      </Button>
    </form>
  )
}
